import React, { FC } from "react"; 
import PlusIcon from "../../../../../images/membership/plus-white.svg";
import DeleteIcon from "../../../../../images/products/trash-white.svg";
import { MediaTypes } from "../enums";
import { CustomLabel } from "@mindmemobile/mm-shared-global";
import { ItemFrame, ItemImage } from "../styles";
 

type IProps = {
  url?: string | any;
  mediaType?: string;
  label?: string;
  price?: string;
  subLabel?: string;
  showDeleteIcon?: boolean;
  onClick: () => void;
  showOverlay?: boolean;
};

const ItemCard: FC<IProps> = ({
  url,
  mediaType,
  label,
  price,
  subLabel,
  showDeleteIcon,
  onClick,
  showOverlay = true,
}) => {
  const renderMedia = () => {
      switch (mediaType) {
          case MediaTypes.Video:
              return (
                  <video style={{ width: '100%' }} controls={false}>
                      <source type="video/ogg" src={url} />
                      <source type="video/m4v" src={url} />
                      <source type="video/mp4" src={url} />
                      <source type="video/youtube" src={url} />
                  </video>
              );
          default:
              return <img src={url} className="product-image" />;
      }
  };
  return (
      <ItemFrame onClick={() => onClick()}>
          <ItemImage>
              {url && renderMedia()}
              {showOverlay && (
                  <div className="overlay-product">
                      <img src={showDeleteIcon ? DeleteIcon : PlusIcon} className="plus-hovered" />
                  </div>
              )}
          </ItemImage>
          <CustomLabel fontSize="12px" fontWeight="600">
              {label}
          </CustomLabel>
          <CustomLabel fontSize="10px">{price}</CustomLabel>
          {subLabel && (
              <CustomLabel fontSize="10px" fontWeight="600" color="#FF4B55">
                  {subLabel}
              </CustomLabel>
          )}
      </ItemFrame>
  );
};
export default ItemCard;
